<lib-default-loading
  [desginOptions]="desginOptions"
  [translations]="translations"
>
</lib-default-loading>